import settings from '../../config/settings';
import DestinationTypes from '../const/DestinationTypes';
import humps from 'humps';
import {getImageUrl} from './ApiUtils';

export function getLogoImageUrl(destination, useCustom = true) {
  let defaultLogoUrl = useCustom ? getImageUrl(destination.customImage) : null;
  defaultLogoUrl = defaultLogoUrl || getImageUrl(destination.image) || getImageUrl(destination.altImage) || '';
  let logoUrl = '';
  if (destination.kind === DestinationTypes.provider) {
    logoUrl = defaultLogoUrl || (settings.widget.providerLogoBaseUrl + humps.decamelize(destination.slug) + '.png');
  } else {
    logoUrl = defaultLogoUrl;
  }
  return logoUrl;
}

export function getTransitionImageUrl(destination) {
  return getImageUrl(destination.transitionImage) || getLogoImageUrl(destination, false);
}
